/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  FeedbackResponse,
  PostApiFeedbackPracticeIdBody,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";
import { customFormDataFn } from "../../customFormDataFn";

export type postApiFeedbackPracticeIdResponse200 = {
  data: FeedbackResponse;
  status: 200;
};

export type postApiFeedbackPracticeIdResponse400 = {
  data: void;
  status: 400;
};

export type postApiFeedbackPracticeIdResponse401 = {
  data: void;
  status: 401;
};

export type postApiFeedbackPracticeIdResponse403 = {
  data: void;
  status: 403;
};

export type postApiFeedbackPracticeIdResponse500 = {
  data: void;
  status: 500;
};

export type postApiFeedbackPracticeIdResponseSuccess =
  postApiFeedbackPracticeIdResponse200 & {
    headers: Headers;
  };
export type postApiFeedbackPracticeIdResponseError = (
  | postApiFeedbackPracticeIdResponse400
  | postApiFeedbackPracticeIdResponse401
  | postApiFeedbackPracticeIdResponse403
  | postApiFeedbackPracticeIdResponse500
) & {
  headers: Headers;
};

export const getPostApiFeedbackPracticeIdUrl = (practiceId: string) => {
  return `/api/feedback/${practiceId}`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Submit in-app feedback (Question / Issue / Idea).
 */
export const postApiFeedbackPracticeId = async (
  practiceId: string,
  postApiFeedbackPracticeIdBody?: PostApiFeedbackPracticeIdBody,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<postApiFeedbackPracticeIdResponseSuccess> => {
  const formData = customFormDataFn(postApiFeedbackPracticeIdBody);
  return authenticatedClient<postApiFeedbackPracticeIdResponseSuccess>(
    getPostApiFeedbackPracticeIdUrl(practiceId),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};
